module.exports = __webpack_public_path__ + "static/logo-white-on-black-alex-hauk-6c24e0b98d3e7ea92a0ee98418c84117.svg";